export type WizardStep = { key: string; label: string; disabled?: boolean };

/** Ported from the mock's `wsteps()`; an `<ol>` so a screen reader reads the order. */
export function WizardSteps({
  steps,
  current,
  label,
  onSelect,
}: {
  steps: WizardStep[];
  current: string;
  label: string;
  onSelect?: ((key: string) => void) | undefined;
}) {
  const at = Math.max(
    0,
    steps.findIndex((step) => step.key === current),
  );
  return (
    <ol className="wsteps" aria-label={label}>
      {steps.map((step, i) => {
        const state = i < at ? "done" : i === at ? "now" : "";
        const reachable = Boolean(onSelect) && !step.disabled && i !== at;
        return (
          <li
            className={`wstep ${state}`.trimEnd()}
            key={step.key}
            aria-current={i === at ? "step" : undefined}
            aria-disabled={step.disabled ? true : undefined}
          >
            <span className="wn">{i < at ? "✓" : i + 1}</span>
            {reachable ? (
              <button type="button" className="wt wt-link" onClick={() => onSelect?.(step.key)}>
                {step.label}
              </button>
            ) : (
              <span className="wt">{step.label}</span>
            )}
            <span className="wsep" />
          </li>
        );
      })}
    </ol>
  );
}
